import { Skeleton } from '@ace-clublabs/shared-component-library';

interface SelectionCardsSkeletonProps {
  count?: number;
}

const SelectionCardsSkeleton = ({ count = 4 }: SelectionCardsSkeletonProps) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <Skeleton
        // biome-ignore lint/suspicious/noArrayIndexKey: only available key
        key={index}
        variant='rectangular'
        width='100%'
        height={128}
        data-testid='selection-card-skeleton'
        sx={{
          borderRadius: 2,
          backgroundColor: 'grey.200',
          mb: 2,
        }}
      />
    ))}
  </>
);

export default SelectionCardsSkeleton;
